import { render } from "./SupplierList.vue?vue&type=template&id=4ad4e336&scoped=true"
import script from "./SupplierList.vue?vue&type=script&lang=js"
export * from "./SupplierList.vue?vue&type=script&lang=js"

import "./SupplierList.vue?vue&type=style&index=0&id=4ad4e336&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad4e336"]])

export default __exports__